<template>
  <v-form
    class="grid-container address-grid mt-2"
    id="address-grid"
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-row>
      <v-col class="no-padding">
        <span v-if="isPrenatal">Lookup mother's address</span>
        <span class="no-padding" v-else>Lookup address</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-icon class="lookup-icon">mdi-magnify</v-icon>
        <vue-google-autocomplete
          :id="idPrefix + 'address-lookup'"
          classname="address-lookup"
          placeholder="Start typing your address"
          :types="'address'"
          class="address-input"
          v-on:placechanged="getAddressData"
          :fields="[
            'address_components',
            'adr_address',
            'alt_id',
            'formatted_address',
            'geometry',
            'icon',
            'id',
            'name',
            'place_id',
            'scope',
            'type',
            'url',
            'utc_offset_minutes',
            'vicinity',
          ]"
          :country="['au', 'nz']"
        >
        </vue-google-autocomplete>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="custom-col col-2">
        <span class="text-title">Unit flat</span>
        <v-text-field
          v-model="unitFlat"
          :id="idPrefix + 'unitFlat'"
          outlined
          :maxlength="limitUnitFlatLevel"
          hide-details="auto"
        ></v-text-field>
      </v-col>
      <v-col class="custom-col">
        <span class="text-title">Street address*</span>
        <v-text-field
          v-model="streetAddress"
          :id="idPrefix + 'streetAddress'"
          :rules="ruleNotNull"
          outlined
          :maxlength="limitStreetAddress"
          hide-details="auto"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="mt-4">
      <v-col class="custom-col">
        <span class="text-title">Suburb*</span>
        <v-text-field
          v-model="city"
          :id="idPrefix + 'city'"
          :rules="ruleNotNull"
          outlined
          :maxlength="limitSuburb"
          hide-details="auto"
        >
        </v-text-field>
      </v-col>
      <v-col class="custom-col col-3">
        <span class="text-title">Postcode*</span>
        <v-text-field
          v-model="postcode"
          :id="idPrefix + 'postcode'"
          :rules="rulePostCode"
          outlined
          :maxlength="limitPostCode"
          hide-details="auto"
        ></v-text-field>
      </v-col>
      <v-col class="custom-col col-3">
        <span class="text-title" v-if="country === 'AUS'">State*</span>
        <span class="text-title" v-else>State/Province</span>
        <v-text-field
          v-if="country === 'NZL'"
          v-model="state"
          :id="idPrefix + 'state'"
          :rules="ruleNotNull"
          outlined
          :maxlength="limitState"
          hide-details="auto"
        >
        </v-text-field>
        <v-select
          v-if="country !== 'NZL'"
          v-model="state"
          :id="idPrefix + 'state'"
          :items="stateList"
          item-text="displayText"
          item-value="value"
          :rules="country === 'AUS' ? ruleNotNull : []"
          outlined
          :maxlength="limitState"
          hide-details="auto"
        ></v-select>
      </v-col>
      <v-col class="custom-col third">
        <span class="text-title">Country*</span>
        <v-select
          v-model="country"
          :value="country"
          :id="idPrefix + 'country'"
          :items="countryList"
          item-text="displayText"
          item-value="value"
          :rules="ruleNotNull"
          @change="state = ''"
          outlined
          hide-details="auto"
        ></v-select>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import FormRulesMixin from "../mixins/FormRulesMixin.vue";
import DropDownMixin from "../mixins/DropDownMixin.vue";
import StorageMixin from "../mixins/StorageMixin";
import UtiliseMixin from "../mixins/UtiliseMixin";
import { useSectionStore } from "../store/SectionStore";

export default {
  components: { VueGoogleAutocomplete },
  mixins: [FormRulesMixin, DropDownMixin, StorageMixin, UtiliseMixin],
  props: {
    idPrefix: String,
    reuseDataObj: Object,
    loadFromStorage: Boolean,
    addressRef: String,
    isPrenatal: Boolean,
  },

  data: function() {
    let inReuseComponent = false;
    if (typeof this.reuseDataObj !== "undefined") {
      if (Object.keys(this.reuseDataObj).length !== 0) {
        inReuseComponent = true;
      }
    }
    return {
      unitFlat: inReuseComponent ? this.reuseDataObj.unitFlat : "",
      streetAddress: inReuseComponent ? this.reuseDataObj.streetAddress : "",
      city: inReuseComponent ? this.reuseDataObj.city : "",
      state: inReuseComponent ? this.reuseDataObj.state : "",
      postcode: inReuseComponent ? this.reuseDataObj.postcode : "",
      country: inReuseComponent ? this.reuseDataObj.country : "AUS",
      inputValue: "",
    };
  },
  watch: {
    loadFromStorage: function(newVal) {
      if (newVal) {
        this.loadComponentData(this.addressRef);
      } else {
        this.unitFlat = "";
        this.streetAddress = "";
        this.city = "";
        this.state = "";
        this.postcode = "";
        this.country = "AUS";
      }
    },
    state() {
      if (this.state === "VIC") {
        useSectionStore().victorianPatient = true;
      } else useSectionStore().victorianPatient = false;
    },
  },

  async mounted() {

  if (window.location.search) {
    let valueToDisplayTextMapping = await this.getDropDownMapping(
      false,
      true
    );

    let testPractitioner = false;

    let urlSearchParams = new URLSearchParams(window.location.search);

    urlSearchParams.forEach((value, key) => {
      if (key === "testPractitioner") {

        testPractitioner = true;

        if (value === "nick" || value === "") {
          this["unitFlat"] = "Lvl 2";
          this["streetAddress"] = "454 Main Street";
          this["city"] = "Springfield";
          this["state"] = "VIC";
          this["country"] = "AUS";
          this["postcode"] = "3001";
        }
        if (value === "julius") {
          this["city"] = "Springfield";
          this["state"] = "QLD";
          this["postcode"] = "7000";
        }
      }
    });

    if (this.addressRef === 'practitioner' && !testPractitioner) {

      let data = {};
      urlSearchParams.forEach((value, key) => {
        data[key] = value;
      });

      // Remove undefined fields
      for (let key of Object.keys(data)) {
        if (typeof data[key] === 'undefined' || data[key] === 'undefined') {
          data[key] = ''; 
        }
      }

      this["unitFlat"] = data["unitFlat"];
      this["streetAddress"] = data["streetAddress"];
      this["city"] = data["city"];
      this["country"] = valueToDisplayTextMapping[data["country"].toLowerCase()];
      this["state"] = data["state"];
      this["postcode"] = data["postcode"];
      }
    };
  },

  methods: {
    /**
     * When the location found
     * @param {Object} addressData Data of the found location
     * @param {Object} placeResultData PlaceResult object
     * @param {String} id Input container ID
     */

    getAddressData(addressData, placeResultData, id) {
      this.unitFlat = addressData.subpremise;

      const combined = [];

      if (addressData.street_number) combined.push(addressData.street_number);
      if (addressData.route) combined.push(addressData.route);
      this.streetAddress = combined.join(" ");
      this.city = addressData.locality;
      this.state = addressData.administrative_area_level_1;
      this.postcode = addressData.postal_code;
      if (addressData.country === "Australia") {
        this.country = "AUS";
      } else if (addressData.country === "New Zealand") {
        this.country = "NZL";
      }
    },
    /**
     * Transfer out the internal field values for this address
     *
     * @returns {{country: string, streetAddress: string, city: string, postcode: string, unitFlat: string, state: string}}
     */

    transferData() {
      if (this.country === "Australia") {
        this.country = "AUS";
      } else if (this.country === "New Zealand") {
        this.country = "NZL";
      }
      return {
        unitFlat: this.unitFlat,
        streetAddress: this.streetAddress,
        city: this.city,
        state: this.state,
        postcode: this.postcode,
        country: this.country,
      };
    },
  },
};
</script>

<style scoped>
.address-input {
  border: 1px solid #999;
  background-color: white;
  border-radius: 4px;
  padding: 8px;
  font-size: 16px;
  color: #333;
  position: relative;
}
::placeholder {
  color: rgb(171, 171, 171);
}
input[type="text"] {
  font-family: "Arial", "Verela", "Varela Round", sans-serif;
  width: 100%;
  padding: 12px 20px;
  box-sizing: border-box;
  padding-left: 36px !important;
}

.autocomplete-container {
  position: relative !important;
  width: 100% !important;
  display: inline-block !important;
}

.lookup-icon {
  position: relative !important;
  top: 50% !important;
  margin-left: 10px;
  color: #aaa !important;
  pointer-events: none !important;
  z-index: 20 !important;
  border: none !important;
  background: transparent !important;
}
.no-padding {
  margin-bottom: -44px !important;
}
</style>
